module.exports = __webpack_public_path__ + "static/bg-blue-f79c834c74b8b0dab63c93bf94147c71.jpg";